(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ReconnectCareCredential', ReconnectCareCredential);

    ReconnectCareCredential.$inject = ['$resource'];

    function ReconnectCareCredential ($resource) {
        var resourceUrl =  'api/reconnect-care-credentials/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByFacility': {url: 'api/reconnect-care-credentials/facility/:id', method: 'GET', isArray: true}
        });
    }
})();
